export default {
	add: 'إضافة إجازة',
	'add-permission': 'إضافة إذن',

	table: {
		employee: 'الموظف',
		requestDate: 'تاريخ الطلب',
		type: 'النوع',
		startDate: 'تاريخ البداية',
		endDate: 'تاريخ النهاية',
		cause: 'السبب',
		status: 'حالة الإجازة',
	},
	'delete-message-vacation': 'هل أنت متأكد أنك تريد حذف الإجازة؟'
};
